import SchemaValidator from './SchemaValidator';

const IsProfileComplete = user => {
    const v = SchemaValidator(user, 'enroll')
    return v.errors.length === 0;
}
export default IsProfileComplete;